import React, { useState } from 'react';
import { Tabs, theme } from 'antd';
import { SecurityScanOutlined } from '@ant-design/icons';

import SecuritySettings from './components/SecuritySettings';
import './ProfileSettings.css';

const { TabPane } = Tabs;

const ProfileSettings = () => {
    const [activeKey, setActiveKey] = useState('security');
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const handleTabChange = (key) => {
        setActiveKey(key);
    };

    return (
        <div
            style={{
                margin: '24px 16px',
                borderRadius: borderRadiusLG,
                minHeight: 280,
            }}
        >
            <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                type="card"
                tabBarGutter={5}
                className="profile-settings-tabs"
            >
                <TabPane
                    tab={<span><SecurityScanOutlined /> Security</span>}
                    key="security"
                >
                    <SecuritySettings />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default ProfileSettings;
